
import { Component, Vue } from 'vue-property-decorator'
import CloseCross from '~/components/common/ctrls/CloseCrossCtrl.vue'

@Component({
  components: {
    CloseCross
  }
})
export default class ReferralModal extends Vue {
  features = [
    { emoji: '🏆', bgStyle: 'background-color: #FFF8E5;', boldText: 'Win scholarships together ', normalText: '- When one wins, both get up to $1,000' },
    { emoji: '💵', bgClass: 'bg-gray-8', boldText: 'Earn $40 per Pro referral ', normalText: '- Get paid when friends subscribe' },
    { emoji: '📊', bgStyle: 'background-color: #FEEFE9;', boldText: 'Track your earnings ', normalText: 'in real-time' }
  ]

  mounted() {
    this.$mixpanel.track(this.$mixpanel.events.REFERRAL_INTRO_POPUP_OPENED)
  }

  handleStartEarningClick() {
    this.$mixpanel.track(this.$mixpanel.events.REFERRAL_INTRO_POPUP_CTA_CLICKED)
    window.location.href = '/registration/refer-and-earn'
  }

  handleMaybeLaterClick() {
    this.$modal.hide('ReferralModal')
  }
}
